export const scrollTop = (domArea)=>{
    document.getElementById(domArea).scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
    });
};
